/*
  These values poll the queue in the background:
    - QUEUE_POLL_TIMER is the interval in ms that the timer runs on
    - QUEUE_POLL represents a time in ms such that if that amount of time has
      passed sense the queue was last fetched, it will trigger another request
      to get a fresh copy of the queue.
*/
export const QUEUE_POLL_TIMER = 10000; // 10 seconds
export const QUEUE_POLL = 300000; // 5 minutes

export const LOADING_LABEL = 'Loading';
export const WORK_QUEUE_LABEL = 'Work Queue';
export const MY_ASSIGNMENTS_LABEL = 'MY ASSIGNMENTS';
export const MANUAL_LABEL = 'MANUAL';
export const APPEAL_RETRO_LABEL = 'APPEAL / RETROSPECTIVE';
export const STATUS_DETERMINATION_LABEL = 'STATUS DETERMINATION';
export const PEER_TO_PEER_LABEL = 'PEER-TO-PEER';
export const CLEAR_FILTERS_LABEL = 'CLEAR FILTERS';
export const MESSAGE_CENTER_LABEL = 'MESSAGE CENTER';
export const RESET_COLUMNS_LABEL = 'RESET COLUMNS';

export const MANUAL_FILTER = 'Manual';
export const APPEAL_RETRO_FILTER = 'Appeal/Retrospective';
export const PEER_TO_PEER_FILTER = 'Peer-to-Peer';
export const PHYSICIAN_ADVISOR_FILTER = 'Physician Advisor';

export const WQ_SORTING_STORAGE_KEY = 'wqSortingState';
export const DEFAULT_WQ_TYPE = 'workQueue';

export const WQ_STORAGE_ERROR_MESSAGE =
  'Error parsing JSON from WQ localStorage:';
